import OldPaginate from './OldPaginate'
import NexPaginate from './NexPaginate'
import SeoPaginate from './SeoPaginate'
import PropertyPublicPaginate from './PropertyPublicPaginate'

export default OldPaginate
export { NexPaginate, SeoPaginate , PropertyPublicPaginate}